import { STRINGS } from 'config';
import React, { useState, useEffect } from 'react';
import { getCustomClinicalClosedClosureMessage } from 'store/action/demandManagement';
import { useAppState } from 'store/configureStore';
import { SettingsSection } from 'components/Setting/style';
import { CustomClosureMessageForm } from 'components/CustomClosureMessage/messageForm';
import { ShowDefaultCustomClosureMessageToggle } from 'components/CustomClosureMessage/messageToggle';
import { Feature, RenderOn } from '@econsult/econsult-ui/dist/components/FlagControlledFeature';

const { IDLE, PENDING, SUCCEEDED, FAILED } = STRINGS.REQUEST_STATUS;
const { DEFAULT_CUSTOM_CLOSURE_MESSAGE_TOGGLE_ENABLED } = STRINGS.FEATURE_FLAGS;

const MAX_MESSAGE_LENGTH = 500;

export const CustomClosureMessage = () => {
  const {
    app: { selectedPracticeHasAdminRights, selectedPractice },
    featureFlags: {
      [DEFAULT_CUSTOM_CLOSURE_MESSAGE_TOGGLE_ENABLED]: featureFlag,
    },
  } = useAppState();
  const [message, setMessage] = useState('');
  const [showDefaultMessage, setShowDefaultMessage] = useState(false);
  const [saveRequestStatus, setSaveRequestStatus] = useState(IDLE);
  const [getRequestStatus, setGetMessageRequestStatus] = useState(IDLE);

  const isGetRequestPending = getRequestStatus === PENDING;
  const isSaveRequestPending = saveRequestStatus === PENDING;
  const isFormDisabled = message.length > MAX_MESSAGE_LENGTH
    || saveRequestStatus === PENDING
    || !selectedPracticeHasAdminRights
    || isGetRequestPending;
  const isToggleDisabled = isSaveRequestPending
    || isGetRequestPending
    || !selectedPracticeHasAdminRights;
  useEffect(() => {
    setGetMessageRequestStatus(PENDING);
    getCustomClinicalClosedClosureMessage(selectedPractice.id).then(response => {
      if (typeof response.customClinicalClosedMessage === 'string') {
        setGetMessageRequestStatus(SUCCEEDED);
        setMessage(response.customClinicalClosedMessage);
        setShowDefaultMessage(!featureFlag ? true : response.showDefaultMessage);
        return;
      }
      setGetMessageRequestStatus(FAILED);
    });
  }, [featureFlag, selectedPractice.id]);

  const onChangeMessage = event => {
    setMessage(event.target.value);
  };

  return (
    <SettingsSection data-automation="CustomClosureMessageWrapper">
      <CustomClosureMessageForm
        message={message}
        showDefaultMessage={showDefaultMessage}
        selectedPractice={selectedPractice}
        selectedPracticeHasAdminRights={selectedPracticeHasAdminRights}
        maxMessageLength={MAX_MESSAGE_LENGTH}
        isFormDisabled={isFormDisabled}
        onChangeMessage={onChangeMessage}
        isGetRequestPending={isGetRequestPending}
        isSaveRequestPending={isSaveRequestPending}
        setSaveRequestStatus={setSaveRequestStatus}
        featureFlag={featureFlag}
      />

      <Feature flags={[DEFAULT_CUSTOM_CLOSURE_MESSAGE_TOGGLE_ENABLED]}>
        <RenderOn>
          <ShowDefaultCustomClosureMessageToggle
            message={message}
            showDefaultMessage={showDefaultMessage}
            selectedPractice={selectedPractice}
            selectedPracticeHasAdminRights={selectedPracticeHasAdminRights}
            maxMessageLength={MAX_MESSAGE_LENGTH}
            setShowDefaultMessage={setShowDefaultMessage}
            isGetRequestPending={isGetRequestPending}
            isSaveRequestPending={isSaveRequestPending}
            setSaveRequestStatus={setSaveRequestStatus}
            isToggleDisabled={isToggleDisabled}
          />
        </RenderOn>
      </Feature>

    </SettingsSection>
  );
};
